import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { apiRequest } from "./api";

// get Token
import useAuthToken from "../../Hooks/useAuthToken";

export const useCreateMenu = () => {
  const token = useAuthToken();

  const createMenu = async (credentials) => {
    if (!credentials) {
      throw new Error("Please provide credentials");
    }
    return apiRequest("post", "/api/menu", credentials, token);
  };

  return createMenu;
};

export const useGetMenu = () => {
  const token = useAuthToken();

  const getMenu = async () => {
    if (!token) {
      throw new Error("Token is missing");
    }

    return apiRequest("get", "/api/menu", null, token);
  };

  return getMenu;
};

// export const useGetMenuById = (id) => {
//   const token = useAuthToken();

//   // Function to fetch category data
//   const getMenuById = async () => {
//     if (!token) {
//       throw new Error("Token is missing");
//     }

//     const response = await apiRequest(
//       "get",
//       `/api/category/${id}`,
//       null,
//       token
//     );

//     return response;
//   };
//   return useQuery({
//     queryKey: ["single-category", id],
//     queryFn: getCategoryById,
//     enabled: !!id,
//   });
// };

export const useUpdateMenu = (id) => {
  const token = useAuthToken();

  const updateMenu = async (formData) => {
    if (!token) {
      throw new Error("Token is missing");
    }
    const response = await apiRequest(
      "patch",
      `/api/menu/${id}`,
      formData,
      token
    );

    return response;
  };

  return updateMenu;
};
